module.exports = __webpack_public_path__ + "video-play.svg";


//////////////////
// WEBPACK FOOTER
// ./~/blueimp-gallery/img/video-play.svg
// module id = 1143
// module chunks = 14